import { Subject, Observable } from 'rxjs';

export class ActionEventEmitter<T> {
    private subject = new Subject<T>();
    get action(): Observable<T> {
        return this.subject;
    }

    public emit(event: T): void {
        this.subject.next(event)
    }
}